'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const FileIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="FileIcon">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" id="Text-File--Streamline-Core">
        <desc>Text File Streamline Icon: https://streamlinehq.com</desc>
        <g id="text-file--text-common-file">
          <path
            id="Union"
            fill="#d7e0ff"
            d="M2.5 0c-0.39782 0 -0.77936 0.158035 -1.06066 0.43934C1.15804 0.720644 1 1.10218 1 1.5v11c0 0.3978 0.15804 0.7794 0.43934 1.0607S2.10217 14 2.5 14h9c0.3978 0 0.7794 -0.158 1.0607 -0.4393S13 12.8978 13 12.5V4c0 -0.13261 -0.0527 -0.25979 -0.1464 -0.35355L9.35355 0.146447C9.25979 0.0526784 9.13261 0 9 0H2.5Z"
            strokeWidth="1"
          ></path>
          <path
            id="Union_2"
            fill="#5073c3"
            fillRule="evenodd"
            d="M3.875 4.5c0 -0.34518 0.27982 -0.625 0.625 -0.625h2c0.34518 0 0.625 0.27982 0.625 0.625s-0.27982 0.625 -0.625 0.625h-2c-0.34518 0 -0.625 -0.27982 -0.625 -0.625Zm0 3c0 -0.34518 0.27982 -0.625 0.625 -0.625h5c0.34518 0 0.625 0.27982 0.625 0.625s-0.27982 0.625 -0.625 0.625h-5c-0.34518 0 -0.625 -0.27982 -0.625 -0.625ZM4.5 9.875c-0.34518 0 -0.625 0.2798 -0.625 0.625s0.27982 0.625 0.625 0.625h5c0.34518 0 0.625 -0.2798 0.625 -0.625s-0.27982 -0.625 -0.625 -0.625h-5Z"
            clipRule="evenodd"
            strokeWidth="1"
          ></path>
        </g>
      </svg>
    </SvgIcon>
  )
}

FileIcon.propTypes = {
  sx: PropTypes.object
}
